import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { showTradeOnApprovalBanner } from '../SbRespTradeOnApprovalPromo/SbRespTradeOnApprovalPromoBanner/sbRespTradeOnApprovalPromoHelpers';

const SbSharedTopTileControllerComponent = props => {
    const { itemSearch, viewer, isUserTypeTrade, tradeOnApprovalBanner, priceTiles } = props;

    const showCategoryTiles = !get(itemSearch, 'browseContentModule');
    const shouldShowPriceTiles = isUserTypeTrade && get(itemSearch, 'priceTiles.length') > 2;

    const appliedFilters = get(itemSearch, 'appliedFilters') || [];
    const usRegions = get(viewer, 'regions') || [];
    const shouldShowTradeOnApprovalBanner =
        isUserTypeTrade &&
        showTradeOnApprovalBanner({ appliedFilters, usRegions }) &&
        !!tradeOnApprovalBanner;

    let content = null;

    // price tiles are currently only on desktop
    if (priceTiles && shouldShowPriceTiles) {
        content = props.priceTiles;
    } else if (shouldShowTradeOnApprovalBanner) {
        content = props.tradeOnApprovalBanner;
    } else if (showCategoryTiles) {
        content = props.categoryTiles;
    }

    return content && <React.Fragment>{content}</React.Fragment>;
};

SbSharedTopTileControllerComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    categoryTiles: PropTypes.node,
    tradeOnApprovalBanner: PropTypes.node,
    priceTiles: PropTypes.node,
    isUserTypeTrade: PropTypes.bool,
};

const mapStateToProps = state => {
    const { header } = state;
    return {
        isUserTypeTrade: header.isUserTypeTrade,
    };
};

export const SbSharedTopTileController = createFragmentContainer(
    connect(mapStateToProps)(SbSharedTopTileControllerComponent),
    {
        itemSearch: graphql`
            fragment SbSharedTopTileController_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        code
                        urlLabel
                    }
                }
                priceTiles(isTrade: $isTrade) {
                    displayName
                }
                browseContentModule(contentModuleId: $contentModuleId) {
                    moduleType
                }
            }
        `,
        viewer: graphql`
            fragment SbSharedTopTileController_viewer on Viewer {
                regions(
                    regionType: ITEM_LOCATION
                    regionBoundaryTypes: [METROPOLITAN, DISTRICT, DOMESTIC]
                    address: { country: "us" }
                ) @include(if: $isTrade) {
                    regionName
                    urlLabel
                }
            }
        `,
    }
);
